import React, { useCallback } from 'react';
import type { ToolProps } from './Tool';
import { Tool } from './Tool';

export type ToggleToolProps = Omit<
  ToolProps,
  'variant' | 'text' | 'aria-expanded' | 'tooltip' | 'onClick'
> &
  Required<Pick<ToolProps, 'tooltip'>> & {
    active: boolean;
    onClick: (newState: boolean) => void;
  };

export function ToggleTool({
  active,
  className,
  onClick,
  ...props
}: ToggleToolProps): React.JSX.Element {
  const cssClasses = ['ehs-toggle-tool', className];
  if (active) {
    cssClasses.push('active');
  }

  const clickHandler = useCallback(() => onClick(!active), [active, onClick]);
  return (
    <Tool
      {...props}
      className={cssClasses.filter(Boolean).join(' ')}
      variant="transparent"
      onClick={clickHandler}
      aria-expanded={active}
    />
  );
}
